<template>
  <div id="app">
    <keep-alive>
      <!-- ここはキャッシュされる画面（Home画面など） -->
      <router-view ref="childView" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view ref="childView" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<style />
<script>
import { Env } from './scripts/AllExport'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  data: function () {
    return {
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let hl = this.$route.query.hl
      if (typeof hl !== 'undefined') {
        if (hl === 'zh' || hl === 'en' || hl === 'jp') {
          Cookies.set('language', hl, { path: '/', expires: Env.COOKIES_TTL })
          this.$i18n.locale = hl
        } else {
          Cookies.set('language', 'en', { path: '/', expires: Env.COOKIES_TTL })
          this.$i18n.locale = 'en'
        }
      } else {
        if (typeof Cookies.get('language') === 'undefined' || Cookies.get('language') === null) Cookies.set('language', 'en', { path: '/', expires: Env.COOKIES_TTL })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue